"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_INVITATION_STATUS = void 0;
exports.USER_INVITATION_STATUS = {
    ACCEPTED: 'accepted',
    CANCELED: 'canceled',
    CREATED: 'created',
    EXPIRED: 'expired',
    SENT: 'sent',
};
//# sourceMappingURL=user-invitation.types.js.map